export default __webpack_public_path__ + "static/media/bold-crm-plus.f011cd22.svg";